$( document ).ready(function() {
  $('.custom-faq-related-content[data-heading-name!="category_1"]').hide();
  $($('[data-heading-name="category_1"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="category_1"]')[$('[data-heading-name="category_1"]').length-1]).addClass('c2-custom-border-bottom');
});
  
$(document).on("click",".custom-faq-related-heading-content",function() {
  $('.custom-faq-related-heading-content.active').removeClass('active');
  $(this).addClass('active');
  var faq_type=$(this).data('heading-name');
  $('.custom-faq-related-content').hide();
  $('.custom-faq-related-content[data-heading-name="'+faq_type+'"]').show();
  $('.custom-faq-related-content').removeClass('c2-custom-border-top');
  $('.custom-faq-related-content').removeClass('c2-custom-border-bottom');
  $($('[data-heading-name="'+faq_type+'"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="'+faq_type+'"]')[$('[data-heading-name="'+faq_type+'"]').length-1]).addClass('c2-custom-border-bottom');
  $('.custom-faq-content1 h3').text($(this).text().trim());
});

$(document).on("click",".custom-faq-related-content",function() {
  if($(this).hasClass('active')){
  	$(this).removeClass('active');
  }else{
	$(this).addClass('active');
  }
});

$('.content_blog_Post').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  arrowShape: window.arrowShape
});

$(document).on("click",".c2-rocommendations-product-add-to-cart",function() {
  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: 1,
    id: $(this).data('id')
  },
    dataType: 'json', 
   success: function (data) { 
    Shopify.theme.jsAjaxCart.updateView();
   } 
   });
});



$(document).on("click",".custom-search-form-btn",function() {
  var search_value = $(this).prev().val();
  window.location.href = "/search?type=product&q="+search_value+"*";
});

$(document).on("click",".mobile-menu__toggle-button",function() {
  $(".dynamic-sections").toggleClass("mobile-menu-active");
});




$('.instagram-row-images').flickity({
  "imagesLoaded": true,
  "prevNextButtons": false,
  "contain": true,
  "freeScroll": true,
  "page-dots": false
  
});


$('.review-row-images').flickity({
  "imagesLoaded": true,
  "prevNextButtons": true,
  "contain": true,
  "freeScroll": true,
  "page-dots": false
});

$(document).ready(function(){
  if(window.location.href.includes('product')){
    $('.product-gallery__thumbnails .flickity-button:disabled').removeAttr('disabled');
  }
  $('.product-gallery__thumbnails .flickity-button').on('click',function(e) {
    e.preventDefault();
    $('.product-gallery__thumbnails .flickity-button:disabled').removeAttr('disabled');
    // if(!$(this).hasClass('previous')){
    //   if($('.product-gallery__thumbnail.is-nav-selected').next().length!=0){
    //     $('.product-gallery__thumbnail.is-nav-selected').next().click();
    //   }else{
    //     var t_lenght = $('.product-gallery__thumbnail').length-1;
    //     $($('.product-gallery__thumbnail')[0]).click();
    //   }
    // }else{
    //   if($('.product-gallery__thumbnail.is-nav-selected').prev().length!=0){
    //     $('.product-gallery__thumbnail.is-nav-selected').prev().click();
    //   }else{
    //     var t_lenght = $('.product-gallery__thumbnail').length-1;
    //     $($('.product-gallery__thumbnail')[t_lenght]).click();
    //   }
    // }
    $('.product-gallery__main').flickity('next');
  })
})
